import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { departmentsAPI } from '../../services/api';

export const fetchDepartments = createAsyncThunk('departments/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await departmentsAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to load departments'); }
});

export const createDepartment = createAsyncThunk('departments/create', async (data, { rejectWithValue }) => {
  try { const res = await departmentsAPI.create(data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to create department'); }
});

export const updateDepartment = createAsyncThunk('departments/update', async ({ id, data }, { rejectWithValue }) => {
  try { const res = await departmentsAPI.update(id, data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to update department'); }
});

export const deleteDepartment = createAsyncThunk('departments/delete', async (id, { rejectWithValue }) => {
  try { await departmentsAPI.delete(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to delete department'); }
});

const departmentsSlice = createSlice({
  name: 'departments',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.departments;
      })
      .addCase(fetchDepartments.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.items.push(action.payload.department);
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        const idx = state.items.findIndex(d => d._id === action.payload.department._id);
        if (idx !== -1) state.items[idx] = action.payload.department;
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.items = state.items.filter(d => d._id !== action.payload);
      });
  },
});

export default departmentsSlice.reducer;
